<template>
  <div class="container logged-out-content">
    <form class="block form-sm" name="changePasswordForm" @submit.prevent="performPasswordReset()">
      <header>
        <div class="pull-left">
          <div class="icon">
            <img src="~assets/images/Patient-Icon.png">
          </div>
        </div>
        <div class="col-xs-9">
          <h2>Change Password</h2>
        </div>
      </header>

      <div class="subheader">
        <p>Please enter your new password below</p>
        <p>
          <i class="glyphicon glyphicon-asterisk"></i> indicates a required field
        </p>
      </div>
      <error-display v-if="errorMessage">{{errorMessage}}</error-display>
      <div class="content">
        <div class="row">
          <input-password name="password" label="Password" v-model="password" :validation="$v.password"></input-password>
        </div>
        <div class="row">
          <input-password name="confirmPassword" label="Confirm Password" v-model="confirmPassword" :validation="$v.confirmPassword"></input-password>
        </div>
      </div>
      <div class="footer">
        <div class="col-xs-12 pointer text-center">
          <submit-button id="perform-password-reset-submit" :loading="loading">Change Password</submit-button>
        </div>
        <div class="clear"></div>
      </div>
    </form>
  </div>
</template>

<script>
  import { required, sameAs } from 'vuelidate/lib/validators';
  import { password } from 'utils/validators';

  import InputPassword from 'components/common/inputs/InputPassword';

  import SubmitButton from 'components/common/buttons/SubmitButton';

  import ErrorDisplay from 'components/common/outputs/ErrorDisplay';

  export default {
    name: 'reset-password',
    components: {
      InputPassword,
      SubmitButton,
      ErrorDisplay,
    },
    data: () => ({
      loading: false,
      errorMessage: '',
      password: '',
      confirmPassword: '',
    }),
    props: ['context', 'hash'],
    validations: {
      password: {
        required,
        password,
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs(model => model.password),
      },
    },
    methods: {
      async performPasswordReset() {
        this.$v.$touch();

        if (this.$v.$invalid) {
          this.errorMessage = this.$api.validationError;
        } else {
          try {
            this.loading = true;

            await this.$api.performPasswordReset({
              password: this.password,
              token: this.hash,
            });

            this.$router.push('/login');
          } catch (error) {
            this.errorMessage = this.$api.processError(error);
          } finally {
            this.loading = false;
          }
        }
      },
    },
    mounted() {
      if (this.context === 'ud') {
        this.$store.dispatch('updateContext', {
          context: 'patient',
        });
      } else if (this.context === 'academic') {
        this.$store.dispatch('updateContext', {
          context: 'academic',
        });
      } else {
        this.$router.push('/');
      }
    },
  };
</script>



// WEBPACK FOOTER //
// ResetPassword.vue?808f5bbc